exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.open-in-browser-link:hover img[data-v-c25e54ca] {\n  opacity: 0.5;\n}\n", ""]);

// exports
